import { jsx as _jsx } from "react/jsx-runtime";
import { Page, PageEmptyState, PageErrorState } from 'seagull';
import PageLoadingState from '~/components/PageLoadingState';
import RestfulWrapper from '~/components/RestfulWrapper/RestfulWrapper';
import { useLocaleKeys } from '~/i18n';
import { useStoreActions } from '~/store/store-context';
import { ActivityLogBusinessItem } from './ActivityLogBusinessItem';
function ActualActivityLogsPage(param) {
    let { data, loading } = param;
    const { t: texts } = useLocaleKeys('pages.activityLogsPage');
    const title = texts.title();
    const businessEntries = data.filter((entry)=>entry.isBusinessEntry());
    const hasData = businessEntries.length > 0;
    return /*#__PURE__*/ _jsx(Page, {
        header: title,
        skin: "secondary",
        testId: "activity-logs-page",
        loading: loading,
        children: hasData ? /*#__PURE__*/ _jsx("div", {
            "data-testid": "activity-logs-content",
            children: businessEntries.map((entry, index)=>/*#__PURE__*/ _jsx(ActivityLogBusinessItem, {
                    entry: entry,
                    isFirst: index === 0,
                    isLast: index === businessEntries.length - 1
                }, entry.id()))
        }) : /*#__PURE__*/ _jsx(PageEmptyState, {
            testId: "activity-logs-empty",
            illustration: null,
            title: texts.emptyTitle(),
            message: texts.emptyMessage()
        })
    });
}
export default function ActivityLogsPage() {
    const { t } = useLocaleKeys('pages.activityLogsPage');
    const title = t.title();
    const { api } = useStoreActions();
    return /*#__PURE__*/ _jsx(RestfulWrapper, {
        fetch: api.business.getActivityLogs,
        renderChild: (param)=>{
            let { data, loading } = param;
            return /*#__PURE__*/ _jsx(ActualActivityLogsPage, {
                data: data,
                loading: loading
            });
        },
        renderLoader: ()=>/*#__PURE__*/ _jsx(PageLoadingState, {
                header: title,
                loading: true
            }),
        renderError: (param)=>{
            let { refresh } = param;
            return /*#__PURE__*/ _jsx(PageErrorState, {
                testId: "activity-logs-error",
                title: title,
                onRefresh: refresh
            });
        }
    });
}
